import { Color } from "@styles/constants";
import { BodyRegular } from "@styles/typography";
import styled from "styled-components";

export const FormContainer = styled.div`
   {
    width: 75%;
    margin-left: auto;
    margin-right: auto;
    margin-top: 100px;
    text-align: center;
  }
`;

export const TransferFooter = styled.footer`
  text-align: center;
`;

export const LegalText = styled.p`
  ${BodyRegular}
  width: 50%;
  margin-top: 20px;
`;

export const ErrorMessage = styled.div`
  display: "flex";
  justify-content: "center";
  padding: 10px 0px 10px 0px;
  background-color: ${Color.red40};
  font-size: 14px;
  color: ${Color.blackBrand};
`;
